/** progressReport Types */
export const GET_PROGRESS_REPORTS = 'GET_PROGRESS_REPORTS';
export const GET_PROGRESS_REPORTS_SUCCESS = 'GET_PROGRESS_REPORTS_SUCCESS';
export const GET_PROGRESS_REPORTS_BY_ID = 'GET_PROGRESS_REPORTS_BY_ID';
export const GET_PROGRESS_REPORTS_BY_ID_SUCCESS = 'GET_PROGRESS_REPORTS_BY_ID_SUCCESS';
export const CREATE_PROGRESS_REPORT = 'CREATE_PROGRESS_REPORT';
export const EDIT_PROGRESS_REPORT = 'EDIT_PROGRESS_REPORT';
export const DELETE_PROGRESS_REPORT = 'DELETE_PROGRESS_REPORT';

/** End */

/** A saved report's status after Save Draft / Submit — kept apart from `progressReportById` so its template is not reloaded. */
export const SET_PROGRESS_REPORT_STATUS = 'SET_PROGRESS_REPORT_STATUS';
